<template>
  <v-row v-if="showContent">
    <v-col>
      <v-alert v-model="showAlert" type="error" dense>
        {{ alertText }}
      </v-alert>

      <v-alert v-model="showPriceInfo" type="info" dense>
        {{ priceInfoText }}
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import PickupFeeJS from '@/objects/PickupFee';

export default {
  name: 'PickupAlert',
  props: {
    pickupFee: {
      validator: (v) => v == null || v instanceof PickupFeeJS,
    },
    visible: Boolean,
  },
  computed: {
    showContent() {
      return this.visible && (this.showAlert || this.showPriceInfo);
    },
    showAlert() {
      if (!this.visible || this.pickupFee == null) {
        return false;
      }

      return !this.pickupFee.isPossible();
    },
    alertText() {
      if (this.showAlert) {
        return this.pickupFee.alertText();
      }
      return '';
    },
    showPriceInfo() {
      if (this.showAlert) {
        return false;
      }

      if (!this.visible || this.pickupFee == null) {
        return false;
      }

      return this.pickupFee.hasPrice();
    },
    priceInfoText() {
      if (!this.showPriceInfo) {
        return '';
      }

      return this.pickupFee.priceText();
    },
  },
};
</script>
